module.exports = __webpack_public_path__ + "media/grandmother.37d9d6d1.mp3";